import React from 'react';
import './RightSidebar.css';

const RightSidebar = ({ plan, onSelectPoi, activePoiId }) => {

    if (!plan) {
        return (
            <aside className='right-sidebar'>
                <div className='placeholder'>
                    <p> Your trip plan will appear here after generation... </p>
                </div>
            </aside>
        );
    }
    return (
        <aside className='right-sidebar'>
            <div className='plan-content'>
                <h2>{plan.tripTitle}</h2>
                <p className='destination'><strong>Destination:</strong> {plan.destination}</p>
                <p className='justification'><em>{plan.justification}</em></p>
                <hr />

                {plan.itinerary.map(dayItem => (
                    <div key={dayItem.day} className='day-card'>
                        <h3>Day {dayItem.day}: {dayItem.title}</h3>

                        {dayItem.activities.map((activity, index) => {

                            const activityId = `day-${dayItem.day}-${index}`;
                            const isActive = activePoiId === activityId;

                            return (
                                <div
                                    key={index}
                                    className={`activity-card ${isActive ? 'active' : ''}`}
                                    onClick={() => onSelectPoi(activityId)}
                                    style={{ cursor: 'pointer', border: isActive ? '2px solid #6FA1EC' : '#ccc' }}
                                >
                                    <h4>{activity.name}</h4>
                                    <p>{activity.description}</p>
                                    <span>Budget: {activity.budgetCategory}</span>
                                </div>
                            );
                        })}

                        {dayItem.accomodationTip && <p className='tip'><strong>Tip (Accomodation):</strong> {dayItem.accomodationTip}</p>}
                        {dayItem.transportTip && <p className='tip'><strong>Tip (Transport):</strong> {dayItem.transportTip}</p>}
                    </div>

                ))}
            </div>
        </aside>
    );
};

export default RightSidebar;